import React, {useContext, useState, useMemo} from 'react'
import {Button, styleAndCapture, FileDownloadIcon, CircularProgress} from 'external/material'

import ExportRollbookForm from './Form'
import { getAllGrades } from 'helpers/gradebook'

import {TeacherContext} from 'teacher/context'


const StyledExportRoolbookButton = styleAndCapture(Button, 'rollbookLabel')(exportRollbookStyles)

export default function ExportRollbookButton(props) {

    const context = useContext(TeacherContext)

    const [exporting, setExporting] = useState(false)

    const {translate} = context
    const endIcon = useMemo(() => {
        return exporting
        ? <CircularProgress size={20} sx={{color: "white"}} />
        : <FileDownloadIcon />
    }, [exporting])
    
    function handleExportClick() {
        if (!exporting) {
            setExporting(true)
            getAllGrades(context).then(data => {
                context.updateState({rollbookContextGradingDialogs: {'export-rollbook': {$set: true}}, rollbookContextGradesToExport: {$set: data}})
                setTimeout(setExporting, 500, false)
            })
        }
    }

    return (<>
          <StyledExportRoolbookButton
              size="small"
              variant="contained"
              endIcon={endIcon}
              onClick={handleExportClick}
              {...props}
          >
              {translate('export-rollbook')}
          </StyledExportRoolbookButton>
          <ExportRollbookForm rollbookLabel={props.rollbookLabel} />
        </>
    )
}


function exportRollbookStyles() {
   return {
       height: 40,
       width: 150,
       fontSize: '12pt',
       backgroundColor: '#2ca5ec',
       textTransform: 'capitalize'
   }
}
